import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { Mail, Phone, MessageCircle, FileText, Package, CreditCard, Users, HelpCircle } from 'lucide-react';

const ArtistSupport = () => {
  return (
    <div>
      <Navbar />
      <div style={{ minHeight: '100vh', backgroundColor: '#fff', paddingTop: '120px', paddingBottom: '60px' }}>
        <div style={{ maxWidth: '1000px', margin: '0 auto', padding: '0 20px' }}>
          <Link to="/" style={{ display: 'inline-block', marginBottom: '20px', color: '#dc2626', textDecoration: 'none', fontSize: '14px' }}>
            ← Back to Home
          </Link>
          
          <div style={{ backgroundColor: '#000', color: '#fff', padding: '40px', marginBottom: '30px', borderRadius: '8px', textAlign: 'center' }}>
            <h1 style={{ fontSize: '2.5rem', fontWeight: 'bold', marginBottom: '10px' }}>Artist Support & Help Center</h1>
            <p style={{ opacity: 0.9, fontSize: '1.1rem' }}>We're here to help you succeed on ARTCARDO</p>
          </div>

          {/* Contact Methods */}
          <div style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '1.75rem', fontWeight: 'bold', color: '#000', marginBottom: '20px', textAlign: 'center' }}>Get In Touch With Us</h2>
            
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '20px', marginBottom: '30px' }}>
              {/* Email Support */}
              <div style={{ backgroundColor: '#fef2f2', padding: '25px', borderRadius: '8px', border: '2px solid #fecaca' }}>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                  <Mail className="w-8 h-8" style={{ color: '#dc2626', marginRight: '10px' }} />
                  <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', color: '#000' }}>Email Support</h3>
                </div>
                <p style={{ color: '#374151', marginBottom: '10px' }}>
                  <strong>Email:</strong> <a href="mailto:dulciaart@gmail.com" style={{ color: '#dc2626', textDecoration: 'underline' }}>dulciaart@gmail.com</a>
                </p>
                <p style={{ color: '#374151', fontSize: '0.9rem' }}>
                  <strong>Response Time:</strong> Within 24-48 hours
                </p>
                <p style={{ color: '#374151', fontSize: '0.9rem', marginTop: '10px' }}>
                  Best for detailed queries, documentation, and non-urgent issues.
                </p>
              </div>

              {/* WhatsApp Support */}
              <div style={{ backgroundColor: '#f0fdf4', padding: '25px', borderRadius: '8px', border: '2px solid #bbf7d0' }}>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                  <MessageCircle className="w-8 h-8" style={{ color: '#16a34a', marginRight: '10px' }} />
                  <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', color: '#000' }}>WhatsApp Support</h3>
                </div>
                <p style={{ color: '#374151', marginBottom: '10px' }}>
                  <strong>Number:</strong> <a href="tel:+919019028615" style={{ color: '#16a34a', textDecoration: 'underline' }}>+91 90190 28615</a>
                </p>
                <p style={{ color: '#374151', fontSize: '0.9rem' }}>
                  <strong>Available:</strong> Mon-Sat, 10 AM - 6 PM IST
                </p>
                <p style={{ color: '#374151', fontSize: '0.9rem', marginTop: '10px' }}>
                  Best for quick questions and urgent issues.
                </p>
              </div>

              {/* Phone Support */}
              <div style={{ backgroundColor: '#eff6ff', padding: '25px', borderRadius: '8px', border: '2px solid #bfdbfe' }}>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                  <Phone className="w-8 h-8" style={{ color: '#2563eb', marginRight: '10px' }} />
                  <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', color: '#000' }}>Phone Support</h3>
                </div>
                <p style={{ color: '#374151', marginBottom: '10px' }}>
                  <strong>Number:</strong> <a href="tel:+919019028615" style={{ color: '#2563eb', textDecoration: 'underline' }}>+91 90190 28615</a>
                </p>
                <p style={{ color: '#374151', fontSize: '0.9rem' }}>
                  <strong>Available:</strong> Mon-Sat, 10 AM - 6 PM IST
                </p>
                <p style={{ color: '#374151', fontSize: '0.9rem', marginTop: '10px' }}>
                  For complex issues requiring immediate assistance.
                </p>
              </div>
            </div>
          </div>

          {/* Support Categories */}
          <div style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '1.75rem', fontWeight: 'bold', color: '#000', marginBottom: '20px', textAlign: 'center' }}>How Can We Help You?</h2>
            
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px' }}>
              
              {/* Onboarding Support */}
              <div style={{ backgroundColor: '#fff', padding: '25px', borderRadius: '8px', border: '1px solid #e5e7eb', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                  <Users className="w-6 h-6" style={{ color: '#dc2626', marginRight: '10px' }} />
                  <h3 style={{ fontSize: '1.2rem', fontWeight: 'bold', color: '#000' }}>Onboarding & Account Setup</h3>
                </div>
                <p style={{ color: '#374151', fontSize: '0.95rem', marginBottom: '10px' }}>We'll help you with:</p>
                <ul style={{ color: '#374151', fontSize: '0.9rem', paddingLeft: '20px', listStyleType: 'disc' }}>
                  <li>Account registration and verification</li>
                  <li>Profile setup and optimization</li>
                  <li>Understanding platform terms and commission structure</li>
                  <li>First product listing guidance</li>
                  <li>GST and PAN registration assistance</li>
                </ul>
              </div>

              {/* Product Listing Support */}
              <div style={{ backgroundColor: '#fff', padding: '25px', borderRadius: '8px', border: '1px solid #e5e7eb', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                  <FileText className="w-6 h-6" style={{ color: '#dc2626', marginRight: '10px' }} />
                  <h3 style={{ fontSize: '1.2rem', fontWeight: 'bold', color: '#000' }}>Product Listing Help</h3>
                </div>
                <p style={{ color: '#374151', fontSize: '0.95rem', marginBottom: '10px' }}>Need assistance with:</p>
                <ul style={{ color: '#374151', fontSize: '0.9rem', paddingLeft: '20px', listStyleType: 'disc' }}>
                  <li>Creating compelling product descriptions</li>
                  <li>Product photography tips</li>
                  <li>Pricing guidance and GST calculation</li>
                  <li>Category selection and tagging</li>
                  <li>Updating or editing existing listings</li>
                  <li>Product approval process</li>
                </ul>
              </div>

              {/* Shipping & Logistics */}
              <div style={{ backgroundColor: '#fff', padding: '25px', borderRadius: '8px', border: '1px solid #e5e7eb', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                  <Package className="w-6 h-6" style={{ color: '#dc2626', marginRight: '10px' }} />
                  <h3 style={{ fontSize: '1.2rem', fontWeight: 'bold', color: '#000' }}>Shipping & Logistics Support</h3>
                </div>
                <p style={{ color: '#374151', fontSize: '0.95rem', marginBottom: '10px' }}>We can guide you on:</p>
                <ul style={{ color: '#374151', fontSize: '0.9rem', paddingLeft: '20px', listStyleType: 'disc' }}>
                  <li>Recommended courier partners</li>
                  <li>Packaging best practices for artwork</li>
                  <li>Shipping cost estimation</li>
                  <li>Order fulfillment process</li>
                  <li>Tracking number updates</li>
                  <li>Handling shipping delays or issues</li>
                </ul>
                <p style={{ color: '#dc2626', fontSize: '0.85rem', marginTop: '10px', fontStyle: 'italic' }}>
                  *Note: Artists are responsible for shipping. ARTCARDO provides guidance and support but does not handle logistics directly.
                </p>
              </div>

              {/* Payment & Commission */}
              <div style={{ backgroundColor: '#fff', padding: '25px', borderRadius: '8px', border: '1px solid #e5e7eb', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                  <CreditCard className="w-6 h-6" style={{ color: '#dc2626', marginRight: '10px' }} />
                  <h3 style={{ fontSize: '1.2rem', fontWeight: 'bold', color: '#000' }}>Payment & Commission Issues</h3>
                </div>
                <p style={{ color: '#374151', fontSize: '0.95rem', marginBottom: '10px' }}>Contact us for:</p>
                <ul style={{ color: '#374151', fontSize: '0.9rem', paddingLeft: '20px', listStyleType: 'disc' }}>
                  <li>Understanding the 15% commission structure</li>
                  <li>Payment settlement timelines</li>
                  <li>Bank account verification issues</li>
                  <li>Payment discrepancies or delays</li>
                  <li>GST invoice generation</li>
                  <li>Refund processing on returns</li>
                  <li>Commission calculations and reporting</li>
                </ul>
              </div>

              {/* Technical Issues */}
              <div style={{ backgroundColor: '#fff', padding: '25px', borderRadius: '8px', border: '1px solid #e5e7eb', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                  <HelpCircle className="w-6 h-6" style={{ color: '#dc2626', marginRight: '10px' }} />
                  <h3 style={{ fontSize: '1.2rem', fontWeight: 'bold', color: '#000' }}>Technical Support</h3>
                </div>
                <p style={{ color: '#374151', fontSize: '0.95rem', marginBottom: '10px' }}>Having technical difficulties?</p>
                <ul style={{ color: '#374151', fontSize: '0.9rem', paddingLeft: '20px', listStyleType: 'disc' }}>
                  <li>Login or password issues</li>
                  <li>Dashboard not loading</li>
                  <li>Image upload problems</li>
                  <li>Browser compatibility issues</li>
                  <li>Mobile app navigation</li>
                  <li>Any other technical glitches</li>
                </ul>
              </div>

              {/* Returns & Quality Issues */}
              <div style={{ backgroundColor: '#fff', padding: '25px', borderRadius: '8px', border: '1px solid #e5e7eb', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                  <Package className="w-6 h-6" style={{ color: '#dc2626', marginRight: '10px' }} />
                  <h3 style={{ fontSize: '1.2rem', fontWeight: 'bold', color: '#000' }}>Returns & Quality Standards</h3>
                </div>
                <p style={{ color: '#374151', fontSize: '0.95rem', marginBottom: '10px' }}>Need help with:</p>
                <ul style={{ color: '#374151', fontSize: '0.9rem', paddingLeft: '20px', listStyleType: 'disc' }}>
                  <li>Understanding return policy</li>
                  <li>Handling return requests from buyers</li>
                  <li>Quality standards and expectations</li>
                  <li>Dispute resolution process</li>
                  <li>Packaging guidelines to avoid damage</li>
                  <li>Commission refund on returns</li>
                </ul>
              </div>

            </div>
          </div>

          {/* FAQ Section */}
          <div style={{ backgroundColor: '#f9fafb', padding: '30px', borderRadius: '8px', marginBottom: '40px' }}>
            <h2 style={{ fontSize: '1.75rem', fontWeight: 'bold', color: '#000', marginBottom: '20px', textAlign: 'center' }}>Frequently Asked Questions</h2>
            
            <div style={{ maxWidth: '800px', margin: '0 auto' }}>
              <div style={{ marginBottom: '20px' }}>
                <h3 style={{ fontSize: '1.1rem', fontWeight: 'bold', color: '#000', marginBottom: '8px' }}>Q: How long does it take to get my account approved?</h3>
                <p style={{ color: '#374151', fontSize: '0.95rem' }}>
                  A: Most artist accounts are reviewed and approved within 24-48 hours. You'll receive an email notification once approved.
                </p>
              </div>

              <div style={{ marginBottom: '20px' }}>
                <h3 style={{ fontSize: '1.1rem', fontWeight: 'bold', color: '#000', marginBottom: '8px' }}>Q: What is the commission structure?</h3>
                <p style={{ color: '#374151', fontSize: '0.95rem' }}>
                  A: ARTCARDO charges a 15% commission on all sales from day one. You receive 85% of the base product price. GST is added on top and passed to the buyer.
                </p>
              </div>

              <div style={{ marginBottom: '20px' }}>
                <h3 style={{ fontSize: '1.1rem', fontWeight: 'bold', color: '#000', marginBottom: '8px' }}>Q: When do I receive payment for my sales?</h3>
                <p style={{ color: '#374151', fontSize: '0.95rem' }}>
                  A: Payments are settled after successful order delivery and completion of the return window (5 days). Typically within 7-10 days post-delivery.
                </p>
              </div>

              <div style={{ marginBottom: '20px' }}>
                <h3 style={{ fontSize: '1.1rem', fontWeight: 'bold', color: '#000', marginBottom: '8px' }}>Q: Who handles shipping?</h3>
                <p style={{ color: '#374151', fontSize: '0.95rem' }}>
                  A: Artists are responsible for shipping their products to buyers. ARTCARDO provides guidance on packaging and recommended courier partners, but logistics are managed by the artist.
                </p>
              </div>

              <div style={{ marginBottom: '20px' }}>
                <h3 style={{ fontSize: '1.1rem', fontWeight: 'bold', color: '#000', marginBottom: '8px' }}>Q: What happens if a buyer returns a product?</h3>
                <p style={{ color: '#374151', fontSize: '0.95rem' }}>
                  A: If a return is approved due to a defect or damage, you'll receive the product back and the 15% commission will be refunded to you. The buyer gets a full refund. See our <Link to="/returns-refunds" style={{ color: '#dc2626', textDecoration: 'underline' }}>Returns & Refunds Policy</Link> for details.
                </p>
              </div>

              <div style={{ marginBottom: '20px' }}>
                <h3 style={{ fontSize: '1.1rem', fontWeight: 'bold', color: '#000', marginBottom: '8px' }}>Q: Can I update my product listings after they're approved?</h3>
                <p style={{ color: '#374151', fontSize: '0.95rem' }}>
                  A: Yes! You can edit product details, update stock, change prices, or add new photos anytime from your Artist Dashboard.
                </p>
              </div>

              <div style={{ marginBottom: '20px' }}>
                <h3 style={{ fontSize: '1.1rem', fontWeight: 'bold', color: '#000', marginBottom: '8px' }}>Q: Do I need GST registration to sell on ARTCARDO?</h3>
                <p style={{ color: '#374151', fontSize: '0.95rem' }}>
                  A: GST registration is recommended but not mandatory. However, if you're registered, please provide your GSTIN for proper invoicing. Contact us if you need guidance on GST registration.
                </p>
              </div>
            </div>
          </div>

          {/* Contact Box */}
          <div style={{ backgroundColor: '#000', color: '#fff', padding: '30px', borderRadius: '8px', textAlign: 'center' }}>
            <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '15px' }}>Still Have Questions?</h2>
            <p style={{ opacity: 0.9, marginBottom: '20px' }}>
              Don't hesitate to reach out. We're here to support your success on ARTCARDO!
            </p>
            <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', flexWrap: 'wrap' }}>
              <a 
                href="mailto:dulciaart@gmail.com" 
                style={{ 
                  backgroundColor: '#dc2626', 
                  color: '#fff', 
                  padding: '12px 24px', 
                  borderRadius: '6px', 
                  textDecoration: 'none',
                  fontWeight: 'bold',
                  display: 'inline-block'
                }}
              >
                Email Us
              </a>
              <a 
                href="https://wa.me/919019028615" 
                target="_blank"
                rel="noopener noreferrer"
                style={{ 
                  backgroundColor: '#16a34a', 
                  color: '#fff', 
                  padding: '12px 24px', 
                  borderRadius: '6px', 
                  textDecoration: 'none',
                  fontWeight: 'bold',
                  display: 'inline-block'
                }}
              >
                WhatsApp Us
              </a>
            </div>
          </div>

        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ArtistSupport;
